import { Button } from '@mantine/core';
import React from 'react';

interface SecondaryButtonProps {
  text: string;
  onClick?: () => void;
  leftSection?: React.ReactNode;
  rightSection?: React.ReactNode;
  mr?: number;
  disabled?: boolean;
}

const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  text,
  mr,
  leftSection,
  rightSection,
  onClick,
  disabled
}) => {
  return (
    <Button
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      type='button'
      variant='outline'
      mr={mr}
      color='#7B2183'
      leftSection={leftSection}
      rightSection={rightSection}
    >
      {text}
    </Button>
  );
};

export default SecondaryButton;
